import { borderRadius, typographyV2 } from '@toggle/design-system';
import { NumericalCellValueStyle } from '@toggle/helpers';
import styled from 'styled-components';

const backgroundColors = {
  [NumericalCellValueStyle.Positive]: 'var(--viz-bullish-soft)',
  [NumericalCellValueStyle.Negative]: 'var(--viz-bearish-soft)',
  [NumericalCellValueStyle.Neutral]: 'transparent',
};

const colors = {
  [NumericalCellValueStyle.Positive]: 'var(--viz-bullish)',
  [NumericalCellValueStyle.Negative]: 'var(--viz-bearish)',
  [NumericalCellValueStyle.Neutral]: 'var(--text-default)',
};

export const RightHeaderWrapper = styled.div<{
  $numericalStyle: NumericalCellValueStyle;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  ${borderRadius.r2};
  background-color: ${({ $numericalStyle }) =>
    backgroundColors[$numericalStyle]};
`;

export const RightHeaderReturnLabel = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const RightHeaderReturnValue = styled.span<{
  $numericalStyle: NumericalCellValueStyle;
}>`
  ${typographyV2.titleBase};
  color: ${({ $numericalStyle }) => colors[$numericalStyle]};
  font-family: var(--font-roboto-mono);
`;
